module.exports = __webpack_public_path__ + "img/preferences-first-screen-pic.d18ecc0b.svg";